import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLAuthCompaniesClient } from "./api/cplauthapi/CPLAuthAPI";

export interface ICompaniesService {
  getCompanyIDFromHost(host: string): Promise<string>;
}

@injectable()
export class CompaniesService implements ICompaniesService {
  @inject(SERVICE_TYPES.CPLAuthCompaniesClient) cplAuthcompaniesClient!: ICPLAuthCompaniesClient;

  getCompanyIDFromHost(host: string): Promise<string> {
    return this.cplAuthcompaniesClient.getCompanyIDFromClientWebPortalAddress(host);
  }
}
